import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-take-in-charge-document-type.reducer';
import { IConsTakeInChargeDocumentType } from 'app/shared/model/cons-take-in-charge-document-type.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTakeInChargeDocumentType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consTakeInChargeDocumentTypeList = useAppSelector(state => state.consTakeInChargeDocumentType.entities);
  const loading = useAppSelector(state => state.consTakeInChargeDocumentType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-take-in-charge-document-type-heading" data-cy="ConsTakeInChargeDocumentTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.home.title">
          Cons Take In Charge Document Types
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.home.createLabel">
              Create new Cons Take In Charge Document Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consTakeInChargeDocumentTypeList && consTakeInChargeDocumentTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consTakeInChargeDocumentTypeList.map((consTakeInChargeDocumentType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consTakeInChargeDocumentType.id}`} color="link" size="sm">
                      {consTakeInChargeDocumentType.id}
                    </Button>
                  </td>
                  <td>{consTakeInChargeDocumentType.code}</td>
                  <td>{consTakeInChargeDocumentType.name}</td>
                  <td>{consTakeInChargeDocumentType.nameAr}</td>
                  <td>{consTakeInChargeDocumentType.nameEn}</td>
                  <td>{consTakeInChargeDocumentType.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consTakeInChargeDocumentType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTakeInChargeDocumentType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTakeInChargeDocumentType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTakeInChargeDocumentType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.home.notFound">
                No Cons Take In Charge Document Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsTakeInChargeDocumentType;
